import React from 'react';
import { ArrowUpRight, Mail } from 'lucide-react';

const FIXELS_LOGO = "https://res.cloudinary.com/dpa295hyx/image/upload/v1766078478/Fixels_White_2_gogp2y.png";

interface Props {
  className?: string;
  variant?: 'light' | 'dark';
}

export const FixelsBadge: React.FC<Props> = ({ className = "", variant = 'dark' }) => {
  const isDark = variant === 'dark';
  
  return (
    <a 
      href="https://fixels.nl" 
      target="_blank" 
      rel="noopener noreferrer"
      className={`group inline-flex items-center gap-3 px-4 py-2 backdrop-blur-md border rounded-full transition-all duration-300 ${
        isDark 
          ? 'bg-black/40 border-white/10 hover:border-white/30 hover:bg-white/5 hover:shadow-[0_0_15px_rgba(255,255,255,0.05)]' 
          : 'bg-white/80 border-black/10 hover:border-black/30 hover:bg-white hover:shadow-md'
      } ${className}`}
    >
      <span className={`text-[10px] uppercase tracking-[0.2em] font-medium transition-colors ${
        isDark ? 'text-neutral-500 group-hover:text-neutral-300' : 'text-neutral-500 group-hover:text-neutral-800'
      }`}>
        Made by
      </span>
      <img 
        src={FIXELS_LOGO} 
        alt="Fixels" 
        className={`h-3 w-auto transition-all duration-300 ${
          isDark ? 'opacity-70 group-hover:opacity-100' : 'opacity-80 group-hover:opacity-100 invert'
        }`} 
      />
    </a>
  );
};

export const FixelsHint: React.FC<Props> = ({ className = "", variant = 'dark' }) => {
  const isDark = variant === 'dark';
  
  return (
    <div className={`mt-12 pt-8 border-t flex flex-col md:flex-row items-start md:items-center justify-between gap-6 ${
      isDark ? 'border-white/5' : 'border-black/5'
    } ${className}`}>
      
      <div className="max-w-md">
        <p className={`text-xs uppercase tracking-widest mb-2 ${isDark ? 'text-neutral-600' : 'text-neutral-400'}`}>
          Concept & Realisatie
        </p>
        <p className={`text-sm font-light leading-relaxed ${isDark ? 'text-neutral-400' : 'text-neutral-600'}`}>
          Interesse in een high-end platform als dit? <br className="hidden md:block" />
          Wij bouwen digitale ervaringen die converteren.
        </p>
      </div>

      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 w-full md:w-auto">
        <FixelsBadge variant={variant} />
        
        <div className="flex items-center gap-4">
          <a 
            href="https://fixels.nl" 
            target="_blank" 
            rel="noopener noreferrer"
            className={`text-xs uppercase tracking-widest flex items-center gap-1 transition-colors ${
              isDark ? 'text-neutral-500 hover:text-white' : 'text-neutral-500 hover:text-black'
            }`}
          >
            Fixels.nl <ArrowUpRight size={12} />
          </a>
          <a 
            href="mailto:contact@fixels.nl" 
            className={`text-xs uppercase tracking-widest flex items-center gap-1 transition-colors ${
              isDark ? 'text-neutral-500 hover:text-white' : 'text-neutral-500 hover:text-black'
            }`}
          >
            Contact <Mail size={12} />
          </a>
        </div>
      </div>
    </div>
  );
};